const NEEDS_QUOTES = /[",\r\n]/;

// Excel and Sheets run a cell that opens with one of these as a formula, so a
// leading quote demotes it back to text.
const FORMULA_START = /^[=+\-@\t\r]/;

const csvCell = value => {
  if (null === value || undefined === value) { return ''; }

  const raw = String(value);
  const text = FORMULA_START.test(raw) ? `'${raw}` : raw;

  return NEEDS_QUOTES.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const toCsv = rows =>
  rows.map(row => row.map(csvCell).join(',')).join('\r\n');

// `csvExport: false` opts out a column that holds links rather than data.
export const exportedColumns = columns => columns.filter(
  column => true !== column.hidden && false !== column.csvExport
);

// `value` is what preflight-tables hands to `content`, so the CSV and the table
// format from one definition.
const cellValue = (column, entry) => {
  const value = entry[column.key];

  return column.value ? column.value({ entry, value }) : value;
};

export const tableCsvRows = (columns, entries) => {
  const exported = exportedColumns(columns);

  return [
    exported.map(column => column.label),
    ...entries.map(entry => exported.map(column => cellValue(column, entry))),
  ];
};
